import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import RejectTransaction from 'containers/TransactionManagerTimeLine/Transaction/RejectTransaction';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import VictimCard from 'containers/TransactionManagerTimeLine/VictimInfo/Card';
import ScaleCases from 'containers/TransactionManagerTimeLine/VictimInfo/ScaleCases';
import RecapDocuments from 'containers/TransactionManagerTimeLine/VictimInfo/RecapDocuments';
import AddTransactionDrawer from 'containers/TransactionManagerTimeLine/DrawerTransaction';
import messages from 'containers/TransactionManagerTimeLine/VictimInfo/messages';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { EMPTY_VICTIM } from 'containers/data-structure';
import {
  TRANSACTION_STEPS,
  SECOND_VALIDATION_INBOXE_TITLE,
  THIRD_VALIDATION_INBOXE_TITLE,
} from 'containers/TransactionManagerTimeLine/constants';
import DecisionStepDialog from 'containers/TransactionManagerTimeLine/DecisionDialog';
import { DECISION_DIALOG } from 'containers/TransactionManagerTimeLine/constants';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import {
  isAssignedArea,
  isCreatorTransaction,
  updateAfterValidation,
} from 'containers/TransactionManagerTimeLine/utils';
import DecisionRecap from 'containers/TransactionManagerTimeLine/VictimInfo/DecisionRecap';
import { extractTimelineVictimInfo } from 'containers/TransactionManagerTimeLine/utils';
import TutorInfo from 'containers/TransactionManagerTimeLine/VictimInfo/TutorInfo';
import {
  VictimType,
  TransactionType,
  TransactionDocumentType,
} from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';

export interface VictimInformationProps {
  intl: IntlShape;
  victim: VictimType;
  listings: any;
  transactionDocuments: TransactionDocumentType[];
  resetUploadedDocument: Function;
  uploadedDocument: any;
  uploadDocument: Function;
  requestAddTransaction: Function;
  requestUpdateTransaction: Function;
  transactionId: number;
  requestGetTransaction: Function;
  claimId: number;
  claimRecap: ClaimRecapType;
  isConsultation?: boolean;
  transactionInfo: TransactionType;
  policyInfo: any;
  claimNumber: string;
  riskKey: string;
  requestMakeDecisionVictimInfo: Function;
  requestRejectTransaction: Function;
  dahirAmounts: any;
  requestGetDocByDocumentumId: Function;
  requestGetDahirAmount: Function;
}
const styledContainer = {
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'flex-end',
};
const VictimInformation: React.FC<VictimInformationProps> = (
  props,
): JSX.Element => {
  const [
    openUpdateTransactionDrawer,
    setOpenUpdateTransactionDrawer,
  ] = useState(false);
  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = useState<any>({
    [DECISION_DIALOG.VALIDATION]: false,
    [DECISION_DIALOG.REFUSAL]: false,
  });
  const [openAddTransactionDrawer, setOpenAddTransactionDrawer] = useState(
    false,
  );
  const [victimValidation, setVictimValidation] = React.useState({});

  const handleToggleTransactionDrawer = () => {
    setOpenUpdateTransactionDrawer(false);
  };
  const handleOpenUpdateTransaction = () => {
    setOpenUpdateTransactionDrawer(true);
  };
  const handleOpenAddTransaction = () => {
    setOpenAddTransactionDrawer(true);
  };

  const handleToggleAddTransactionDrawer = () => {
    setOpenAddTransactionDrawer(false);
  };

  const handleIsDialogOpen = (dialog: string) => () => {
    setIsDialogOpen({
      ...isDialogOpen,
      [dialog]: !get(isDialogOpen, `${dialog}`, false),
    });
  };
  const timeLineTask = get(props.transactionInfo, 'timeLine', [])?.find(
    (el: any) => el.step === TRANSACTION_STEPS.VICTIM_INFO,
  );
  const shouldDisplayDecisionButton = () => {
    const pendingTasks = get(props.transactionInfo, 'timeLine', []).find(
      (el: any) =>
        el.step === TRANSACTION_STEPS.VICTIM_INFO &&
        el.status != STATUS_VALIDATED,
    );
    const currentUserInboxes = isAssignedArea(
      props.transactionInfo,
      props.listings,
      SECOND_VALIDATION_INBOXE_TITLE,
    );
    return (
      !props.isConsultation && !isEmpty(pendingTasks) && currentUserInboxes
    );
  };
  const shouldDisplayUpdateButton = () => {
    const pendingSecondTasks = get(props.transactionInfo, 'timeLine', []).find(
      (el: any) =>
        el.step === TRANSACTION_STEPS.VICTIM_INFO &&
        el.status != STATUS_VALIDATED,
    );
    const pendingThirdTasks = get(props.transactionInfo, 'timeLine', []).find(
      (el: any) =>
        el.step === TRANSACTION_STEPS.VICTIM_INFO_THIRD_VALIDATION &&
        el.status != STATUS_VALIDATED,
    );

    const isCreator = isCreatorTransaction(props.transactionInfo);
    const hasQuotation = !isNil(
      get(props.transactionInfo, 'transactionQuotation.evaluationKey', null),
    );
    return !props.isConsultation &&
      (isAssignedArea(
        props.transactionInfo,
        props.listings,
        SECOND_VALIDATION_INBOXE_TITLE,
      ) ||
        isCreator) &&
      !isEmpty(pendingSecondTasks) &&
      !hasQuotation
      ? true
      : !props.isConsultation &&
        isAssignedArea(
          props.transactionInfo,
          props.listings,
          THIRD_VALIDATION_INBOXE_TITLE,
        ) &&
        (isEmpty(pendingThirdTasks) || !isEmpty(pendingThirdTasks)) &&
        !hasQuotation
      ? true
      : false;
  };
  const shouldDisplayThirdValidationDecisionButton = () => {
    const pendingTasks = get(props.transactionInfo, 'timeLine', []).find(
      (el: any) =>
        el.step === TRANSACTION_STEPS.VICTIM_INFO_THIRD_VALIDATION &&
        el.status != STATUS_VALIDATED,
    );

    const currentUserInboxes = isAssignedArea(
      props.transactionInfo,
      props.listings,
      THIRD_VALIDATION_INBOXE_TITLE,
    );
    return (
      !props.isConsultation && !isEmpty(pendingTasks) && currentUserInboxes
    );
  };
  const dropDownMenuElements = () => {
    return featureService.hasFeature(FEATURES.TRANSACTION_V2)
      ? [
          {
            title: translate(messages.validateButton, props),
            action: handleIsDialogOpen(DECISION_DIALOG.VALIDATION),
            disabled: false,
          },
          {
            title: translate(messages.rejectButton, props),
            action: handleIsDialogOpen(DECISION_DIALOG.REFUSAL),
            disabled: false,
          },
        ]
      : [
          {
            title: translate(messages.validateButton, props),
            action: handleIsDialogOpen(DECISION_DIALOG.VALIDATION),
            disabled: false,
          },
        ];
  };
  return (
    <>
      {featureService.hasFeature(FEATURES.TRANSACTION_V2) && (
        <RejectTransaction
          requestRejectTransaction={props.requestRejectTransaction}
          transactionInfo={props.transactionInfo}
        />
      )}
      <DecisionRecap decision={timeLineTask} />
      {!props.isConsultation &&
        (isAssignedArea(
          props.transactionInfo,
          props.listings,
          SECOND_VALIDATION_INBOXE_TITLE,
        ) ||
          isAssignedArea(
            props.transactionInfo,
            props.listings,
            THIRD_VALIDATION_INBOXE_TITLE,
          ) ||
          isCreatorTransaction(props.transactionInfo)) && (
          <div style={styledContainer}>
            <PrimaryButton
              background={'#fff'}
              titlecolor={'rgba(0, 117, 201, 1)'}
              border={'rgba(213, 218, 225, 1)'}
              padding={'20px'}
              onClick={handleOpenAddTransaction}
              data-testId="add-victim"
              title={translate(messages.addVictim, props)}
            />
            <div style={{ marginLeft: 10 }}>
              {shouldDisplayUpdateButton() && (
                <PrimaryButton
                  background={'#fff'}
                  titlecolor={'rgba(0, 117, 201, 1)'}
                  border={'rgba(213, 218, 225, 1)'}
                  padding={'20px'}
                  data-testId="update-transaction"
                  onClick={handleOpenUpdateTransaction}
                  title={
                    updateAfterValidation(
                      get(props.transactionInfo, 'timeLine', []),
                    ) &&
                    isAssignedArea(
                      props.transactionInfo,
                      props.listings,
                      THIRD_VALIDATION_INBOXE_TITLE,
                    )
                      ? translate(messages.modificationAfterValidation, props)
                      : translate(messages.updateButtonTitle, props)
                  }
                />
              )}
            </div>
          </div>
        )}
      <VictimCard
        victim={props.victim}
        listings={props.listings}
        isReadOnly={true}
        couldAddBeneficiaries={true}
        lossDate={(get(props.claimRecap, 'claim.lossDate') as unknown) as Date}
        claimId={props.claimId}
        isConsultation={props.isConsultation}
      />
      {!isEmpty(get(props.transactionInfo, 'tutorInfo', {})) && (
        <TutorInfo tutorInfo={get(props.transactionInfo, 'tutorInfo', {})} />
      )}
      <ScaleCases
        listings={props.listings}
        claim={get(props.transactionInfo, 'scaleCase')}
      />
      <RecapDocuments
        documents={props.transactionDocuments}
        receptionDate={get(props.transactionInfo, 'receptionDate')}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        revenu={get(props.transactionInfo, 'victim.annualOfIncome')}
      />
      <AddTransactionDrawer
        open={openUpdateTransactionDrawer}
        handleToggleDrawer={handleToggleTransactionDrawer}
        index={0}
        listings={props.listings}
        data={{
          victims: [props.victim],
          claim: get(props.claimRecap, 'claim'),
        }}
        dataClaimToUpdate={props.claimRecap}
        resetUploadedDocument={props.resetUploadedDocument}
        uploadedDocument={props.uploadedDocument}
        uploadDocument={props.uploadDocument}
        requestAddTransaction={props.requestAddTransaction}
        transactionDocuments={props.transactionDocuments}
        isUpdate={true}
        requestUpdateTransaction={props.requestUpdateTransaction}
        transactionId={props.transactionId}
        victimInfo={props.victim}
        claimId={props.claimId}
        riskKey={props.riskKey}
        claimNumber={props.claimNumber}
        requestGetTransaction={props.requestGetTransaction}
        scaleCaseInfo={get(props.transactionInfo, 'scaleCase')}
        policyInfo={props.policyInfo}
        claimVictims={get(props.claimRecap, 'victims', [])}
        victimValidation={victimValidation}
        setVictimValidation={setVictimValidation}
        receptionDate={get(props.transactionInfo, 'receptionDate')}
        transactionInfo={props.transactionInfo}
        dahirAmounts={props.dahirAmounts}
      />
      <AddTransactionDrawer
        open={openAddTransactionDrawer}
        handleToggleDrawer={handleToggleAddTransactionDrawer}
        index={0}
        listings={props.listings}
        data={{
          victims: [{ ...EMPTY_VICTIM }],
          claim: get(props.claimRecap, 'claim'),
        }}
        dataClaimToUpdate={props.claimRecap}
        resetUploadedDocument={props.resetUploadedDocument}
        uploadedDocument={props.uploadedDocument}
        uploadDocument={props.uploadDocument}
        requestAddTransaction={props.requestAddTransaction}
        transactionDocuments={[]}
        isUpdate={false}
        requestUpdateTransaction={props.requestUpdateTransaction}
        transactionId={null}
        victimInfo={{}}
        claimId={props.claimId}
        requestGetTransaction={props.requestGetTransaction}
        scaleCaseInfo={get(props.claimRecap, 'claim')}
        policyInfo={props.policyInfo}
        claimNumber={props.claimNumber}
        riskKey={props.riskKey}
        victimValidation={victimValidation}
        setVictimValidation={setVictimValidation}
        claimVictims={get(props.claimRecap, 'victims', [])}
        receptionDate={(null as unknown) as Date}
        transactionInfo={([] as unknown) as TransactionType}
        dahirAmounts={[]}
      />
      {(shouldDisplayDecisionButton() ||
        shouldDisplayThirdValidationDecisionButton()) && (
        <DropDownDecisionMenu
          setDropDown={setDropDown}
          dropDown={dropDown}
          label={translate(messages.managerDecision, props)}
          menuElements={dropDownMenuElements()}
        />
      )}

      <DecisionStepDialog
        isManager={true}
        open={isDialogOpen[DECISION_DIALOG.VALIDATION]}
        handleClose={handleIsDialogOpen(DECISION_DIALOG.VALIDATION)}
        status={STATUS_VALIDATED}
        requestMakeDecisionVictimInfo={props.requestMakeDecisionVictimInfo}
        timeLine={extractTimelineVictimInfo(
          props.transactionInfo,
          STATUS_VALIDATED,
        )}
        transactionInfo={props.transactionInfo}
        riskId={props.riskKey}
        victimKey={get(props.victim, 'victimKey')}
        dahirAmounts={props.dahirAmounts}
        claim={get(props.claimRecap, 'claim')}
        victims={get(props.claimRecap, 'victims', [])}
      />
      <DecisionStepDialog
        isManager={true}
        open={isDialogOpen[DECISION_DIALOG.REFUSAL]}
        handleClose={handleIsDialogOpen(DECISION_DIALOG.REFUSAL)}
        status={STATUS_REJECTED}
        requestMakeDecisionVictimInfo={props.requestMakeDecisionVictimInfo}
        timeLine={extractTimelineVictimInfo(
          props.transactionInfo,
          STATUS_PENDING,
        )}
        transactionInfo={props.transactionInfo}
        riskId={props.riskKey}
        victimKey={get(props.victim, 'victimKey')}
        dahirAmounts={props.dahirAmounts}
        claim={get(props.claimRecap, 'claim')}
        victims={get(props.claimRecap, 'victims', [])}
      />
    </>
  );
};
export default injectIntl(VictimInformation);
